import { ControllerType } from '@/common/types/student';
import { getAnchorPlugin } from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';
import AssessmentUI from '@/game/scenes/Assessment/AssessmentUI';

/* START OF COMPILED CODE */

import DefaultButton from '../GeneralUI/Buttons/DefaultButton';
import UIBlocker from '../GeneralUI/UIBlocker';

/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class SwitchControlsModal extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // uIBlocker
    const uIBlocker = new UIBlocker(scene, 0, 0);
    this.add(uIBlocker);

    // mainContainer
    const mainContainer = scene.add.container(339, 187.5);
    this.add(mainContainer);

    // mainBacking
    const mainBacking = scene.add.nineslice(
      0,
      0,
      'Hud1',
      undefined,
      112,
      48,
      12,
      12,
      12,
      12,
    );
    mainBacking.scaleX = 4;
    mainBacking.scaleY = 4;
    mainContainer.add(mainBacking);

    // switchContextButton
    const switchContextButton = new DefaultButton(scene, 0, 52);
    mainContainer.add(switchContextButton);

    // switchToMousePrompt
    const switchToMousePrompt = scene.add.container(0, -18);
    mainContainer.add(switchToMousePrompt);

    // switchToMouseText
    const switchToMouseText = scene.add.bitmapText(
      0,
      0,
      'Aronui',
      "Don't have a keyboard? Press the button below to switch to letter tiles:",
    );
    switchToMouseText.setOrigin(0.5, 0.5);
    switchToMouseText.tintTopLeft = 5387071;
    switchToMouseText.tintTopRight = 5387071;
    switchToMouseText.tintBottomLeft = 5387071;
    switchToMouseText.tintBottomRight = 5387071;
    switchToMouseText.text =
      "Don't have a keyboard? Press the button below to switch to letter tiles:";
    switchToMouseText.fontSize = -14;
    switchToMouseText.maxWidth = 220;
    switchToMousePrompt.add(switchToMouseText);

    // switchToKeyboardPrompt
    const switchToKeyboardPrompt = scene.add.container(0, -18);
    mainContainer.add(switchToKeyboardPrompt);

    // switchToKeyboardText
    const switchToKeyboardText = scene.add.bitmapText(
      0,
      0,
      'Aronui',
      'Want to type your answers? Press the button to switch to keyboard:',
    );
    switchToKeyboardText.setOrigin(0.5, 0.5);
    switchToKeyboardText.tintTopLeft = 5387071;
    switchToKeyboardText.tintTopRight = 5387071;
    switchToKeyboardText.tintBottomLeft = 5387071;
    switchToKeyboardText.tintBottomRight = 5387071;
    switchToKeyboardText.text =
      'Want to type your answers? Press the button to switch to keyboard:';
    switchToKeyboardText.fontSize = -16;
    switchToKeyboardText.maxWidth = 220;
    switchToKeyboardPrompt.add(switchToKeyboardText);

    // headerContainer
    const headerContainer = scene.add.container(0, -88);
    mainContainer.add(headerContainer);

    // headerBacking
    const headerBacking = scene.add.nineslice(
      0,
      0,
      'Hud2',
      undefined,
      70,
      12,
      4,
      4,
      4,
      4,
    );
    headerBacking.scaleX = 4;
    headerBacking.scaleY = 4;
    headerContainer.add(headerBacking);

    // headerText
    const headerText = scene.add.bitmapText(0, 0, 'Aronui', 'Switch Controls');
    headerText.setOrigin(0.5, 0.5);
    headerText.tintTopLeft = 3023407;
    headerText.tintTopRight = 3023407;
    headerText.tintBottomLeft = 3023407;
    headerText.tintBottomRight = 3023407;
    headerText.text = 'Switch Controls';
    headerText.fontSize = -20;
    headerContainer.add(headerText);

    // switchContextButton (prefab fields)
    switchContextButton.buttonText = 'Switch!';

    this.switchContextButton = switchContextButton;
    this.switchToMousePrompt = switchToMousePrompt;
    this.switchToKeyboardPrompt = switchToKeyboardPrompt;
    this.mainContainer = mainContainer;

    /* START-USER-CTR-CODE */
    this.switchContextButton.controller.setSubmissionCallback(() =>
      this.switchContext(),
    );
    this.setVisible(false);
    /* END-USER-CTR-CODE */
  }

  public switchContextButton: DefaultButton;
  public switchToMousePrompt: Phaser.GameObjects.Container;
  public switchToKeyboardPrompt: Phaser.GameObjects.Container;
  private mainContainer: Phaser.GameObjects.Container;

  /* START-USER-CODE */

  public assessmentUI?: AssessmentUI;

  openForControllerType(control: ControllerType) {
    this.initializeResponsiveness();
    this.setVisible(true);
    this.switchToMousePrompt.setVisible(control === ControllerType.KEYBOARD);
    this.switchToKeyboardPrompt.setVisible(
      control === ControllerType.CLICK || control === ControllerType.DRAG,
    );
  }

  switchContext() {
    if (!this.assessmentUI) return;
    const currentScheme = this.assessmentUI.getControlScheme();
    if (
      currentScheme === ControllerType.CLICK ||
      currentScheme === ControllerType.DRAG
    ) {
      this.assessmentUI.controller.initiateKeyboardOverride();
    } else if (currentScheme === ControllerType.KEYBOARD) {
      this.assessmentUI.controller.initiateLetterCardOverride();
    }
    this.setVisible(false);
  }

  initializeResponsiveness() {
    const anchor = getAnchorPlugin(this.scene);
    anchor.add(this.mainContainer, {
      centerX: '50%',
      centerY: '50%',
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
